export default __webpack_public_path__ + "static/media/eye-lock.64170c80.svg";